export default {
    getUser: state => state.user,
    getInCall: state => state.inCall,
    getCall: state => state.call,
    getNotAvailable: state => state.notAvailable,
    getLabelCalling: state => {
        if(!state.call)
            return ''
        if(state.call.direction==='out' &&  state.call.state==='new')
            return 'Идёт вызов...'
        if(state.call.direction==='in' &&  state.call.state==='new')
            return 'Входящий вызов'
        if(state.call.state==='connected')
            return 'Разговор с клиентом'
        return ''
    },
    getReasonEndCall: state => {
        if(!state.lastCall || !!state.call)
            return null
        // answerTime:1667812777
        // creationTime : 1667812774
        // direction:"in"
        // displayName:"9118377388"
        // hangupTime: 1667812795
        if( state.lastCall.creationTime === state.lastCall.hangupTime )
            return "Номер недоступен"
        return null
    },

    getStatus: state => {
        if(state && state.user && state.user.state)
            return state.user.state
        return 'disabled'
    },
}
